import React, { useEffect, useRef, useState } from "react";
import {
  Backdrop,
  Button,
  DevNote,
  Divider,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  LogoLoader,
  PageHeader,
  PageTitle,
  showToast,
  SmartTooltip,
  StatusTags,
  TableAdv,
  useFormHandler,
} from "../../../../../components";
import { v4 as uuidv4 } from "uuid";
import ShowRevisionHistoryModal from "./Payconfigurations/ShowRevisionHistoryModal";
import ReviseTimesheetsModal from "./Payconfigurations/ReviseTimesheetsModal";
import AdjustPayCycleModal from "./Payconfigurations/AdjustPayCycleModal";
import { PayType } from "../../../../../assets/data/enumData";
import {
  BasepayOpetions,
  LCStypes,
  Paymenttypeopetions,
  PayPeriodoptions,
  PayProfile,
  PayProfileoptions,
  perDiemPaymentTypeOptions,
} from "../../../../../assets/data/projectData";
import { mapTableRows } from "../../../../../utils";
import { PayPeriodRows } from "../../../../../assets/data/candidatesData";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllImmigrationsStart } from "../../../../../redux/slices/immigration/immigrationSlice";
import {
  clearPlacementsData,
  getAllPlacementsStart,
} from "../../../../../redux/slices/placements/placementsSlice";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import {
  addEmployeePayConfigure,
  getCurrentEmployeePayConfig,
} from "../../../../../redux/slices/payroll/payrollSlice";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../../utils/filterEmptyValues";
import dayjs from "dayjs";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { exactUTCDate } from "../../../../../utils/dateFormator";
import { useNavigate } from "react-router-dom";

const Payconfigurations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
    totalCount,
  } = useSelector((state) => state.employee);
  const { placements } = employeeDetails || {};
  const { immigrations: immigrationsTableData } = useSelector(
    (state) => state.immigration,
  );
  const { placements: placementsTableData } = useSelector(
    (state) => state.placement,
  );
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const { loading, empPayConfig } = useSelector((state) => state.payRoll);
  const empPayConfigData = empPayConfig?.data || [];

  const isLoading = !!loading;
  const placementId = placementsTableData?.data || [];
  console.log("placementId", placementId);
  const immigrationsLca = immigrationsTableData?.data?.lca || [];
  // Step 1: Filter valid placements
  const filteredPlacements = placementId.filter(
    (item) => item.clientPlacement?.placement,
  );
  const filteredPlacementsActive = filteredPlacements.filter(
    (item) => item.jobInfo?.status === 1,
  );
  const filteredPlacementsInactive = filteredPlacements.filter(
    (item) => item.jobInfo?.status === 2,
  );

  // Step 2: Format for dropdown or UI
  const formattedPlacements = filteredPlacementsActive.map((item) => ({
    label: item.clientPlacement.placement,
    value: item.uiid,
  }));
  const [isReviseTimesheetsModal, setISReviseTimesheetsModal] = useState(false);
  const [isAdjustPayCycleModal, setISAdjustPayCycleModal] = useState(false);
  const [showRevisionHistoryModal, setShowRevisionHistoryModal] =
    useState(false);
  const [isPayTypeModalOpen, setIsPayTypeModalOpen] = useState(false);
  const containerRef = useRef(null);
  const [activeTab, setActiveTab] = useState(1);
  const [lcaList, setLcaList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [predictData, setPredictData] = useState([]);
  const defaultValue = {
    payProfile: "",
    Placement: "",
    payPeriod: "",
    paymentType: "",
    onlyBasePayIsPaid: [],
    basePay: "",
    payCycle: "",
    basePayMonth: "",
    perDiemPaymentType: "",
    payType: "",
    visaClassification: [
      {
        id: uuidv4(),
        visaClasificationSelect: "",
      },
    ],
  };
  const rules = {
    payProfile: { type: "select", required: true },
    Placement: { type: "select", required: true },
    payPeriod: { type: "select", required: true },
  };
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    defaultValue,
    rules,
  );
  const getCurrentPlace = () => {
    const placeKey = `place${activeTab}`;
    return formData?.employmentPlace?.[placeKey] || {};
  };

  const getCurrentPlaceErrors = () => {
    return errors?.employmentPlace?.[`place${activeTab}`] || {};
  };

  const PayPeriodColumns = [
    { key: "payPeriods", label: "Pay Period" },
    { key: "payDays", label: "Pay Day" },
  ];

  const mappedRows = mapTableRows(tableData, PayPeriodColumns);
  useEffect(() => {
    dispatch(
      getEmployeeByUiidStart({
        uiid: employeeProfileUiid,
        tab: "placementsTab",
        ret: "placements immigrations",
      }),
    );
    // }, [employeeDetails]);
  }, []);

  useEffect(() => {
    const fetchLCAData = async () => {
      // if (placements && placements.length > 0) {
      if (employeeDetails?.employmentType === 4) {
        let filtersForParentEmployee = {
          uiid: {
            type: "NONE",
            value: employeeDetails?.linkedTo?.uiid,
          },
        };
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEES.GET_BY_UIID,
          params: {
            coll: "Employee",
            // lim: limit,
            // pg: page,
            fil: JSON.stringify(filtersForParentEmployee),
            // ref: "Payroll Employee",
          },
        });
        console.log(
          "response form the parent employee",
          response?.data?.data?.placements || [],
        );
        let parentPlacements = response?.data?.data?.placements || [];
        dispatch(
          getAllPlacementsStart({
            fil: { uiid: { type: "IN", value: parentPlacements } },
            cache: false,
            ref: "Client",
            incl: ["uiid businessName"],
          }),
        );
      } else {
        dispatch(
          getAllPlacementsStart({
            fil: { uiid: { type: "IN", value: placements } },
            cache: false,
            ref: "Client",
            incl: ["uiid businessName"],
          }),
        );
      }
      // }
      if (employeeProfileUiid) {
        const filter = {
          employeeId: { type: "NONE", value: employeeProfileUiid },
          endDate: { type: "GTE", value: new Date() },
        };
        try {
          const response = await axiosRequest({
            method: "GET",
            url: ENDPOINTS.LCA.GET_ALL,
            params: {
              coll: "LCA",
              fil: JSON.stringify(filter),
              ret: "uiid number endDate startDate salaryInfo",
            },
          });

          if (response?.success) {
            const filterDatesActive = response.data?.data?.filter(
              (data) => new Date(data.endDate) > new Date(),
            );
            const findActive = filterDatesActive[0];
            if (findActive && empPayConfigData.length === 0) {
              if (formData.wageRate !== findActive?.salaryInfo?.wageRate) {
                handleChange("wageRate", findActive.salaryInfo.wageRate);
              }
              if (formData.basePay !== findActive?.startDate) {
                handleChange("basePay", findActive.startDate);
              }
              if (formData.payCycle !== findActive?.endDate) {
                handleChange("payCycle", findActive.endDate);
              }

              const startDate = findActive?.startDate
                ? new Date(findActive.startDate)
                : null;
              const endDate = findActive?.endDate
                ? new Date(findActive.endDate)
                : null;

              if (startDate && endDate) {
                const diffTime = Math.abs(endDate - startDate);
                const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365);
                const newLcaType = diffYears >= 1 ? 2 : 1; // 2 = Yearly, 1 = Monthly
                if (formData.lcatype !== newLcaType) {
                  handleChange("lcatype", newLcaType);
                }
                const wageRate =
                  parseFloat(findActive?.salaryInfo?.wageRate) || 0;
                // If it's yearly (2), divide by 12 to get monthly; otherwise use the original
                const monthlyAmount =
                  newLcaType === 2 ? wageRate / 12 : wageRate;
                handleChange("basePayMonth", Number(monthlyAmount.toFixed(2)));
              }
            }
            setLcaList(filterDatesActive);
          } else {
            setLcaList([]);
          }
        } catch (error) {
          console.error("Error fetching LCA data:", error);
          setLcaList([]);
        }
      }
    };
    // if (employeeDetails?.employmentType !== 4) {
    // if (Number(employeeDetails?.employmentType) !== 4) {
    fetchLCAData();
    // }
  }, [placements, employeeDetails?.employmentType]);
  // }, [placements, employeeDetails?.employmentType]);
  const handleLcaType = (value) => {
    handleChange("lcatype", value);
    const wageRate = parseFloat(formData?.wageRate) || 0;
    const monthlyAmount = value === 2 ? wageRate / 12 : wageRate;
    handleChange("basePayMonth", Number(monthlyAmount.toFixed(2)));
  };
  // const handleChangePayProfile = (value) => {
  //   handleChange("payProfile", value);
  //   const find = filteredPlacementsActive.find(
  //     (data) => data.uiid === formData?.Placement
  //   );
  //   const startDate = find?.jobInfo?.startDate;
  //   if (!startDate) return;
  //   const selectedDate = dayjs(startDate);
  //   const newTableData = [];
  //   const newPredictData = [];
  //   const formatDateLocal = (date) => date.toLocaleDateString("en-CA");

  //   // Helper: get last day of the month
  //   const getLastDayOfMonth = (date) =>
  //     new Date(date.getFullYear(), date.getMonth() + 1, 0);

  //   // First period: from startDate to month end
  //   let periodStart = dayjs(selectedDate);
  //   let periodEnd = getLastDayOfMonth(selectedDate);

  //   for (let i = 0; i < 5; i++) {
  //     const payDay = new Date(
  //       periodEnd.getFullYear(),
  //       periodEnd.getMonth() + 1,
  //       15
  //     );

  //     newPredictData.push({
  //       label: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //         periodEnd
  //       )}`,
  //       value: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //         periodEnd
  //       )}`,
  //     });

  //     newTableData.push({
  //       payPeriods: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //         periodEnd
  //       )}`,
  //       payDays: formatDateLocal(payDay),
  //     });

  //     // Next period start: 1st day of next month
  //     periodStart = new Date(
  //       periodEnd.getFullYear(),
  //       periodEnd.getMonth() + 1,
  //       1
  //     );

  //     // Next period end: last day of next month
  //     periodEnd = getLastDayOfMonth(periodStart);
  //   }
  //   setTableData([]);
  //   setPredictData(newPredictData);
  //   handleChange("payPeriod", "");
  // };
  const handleChangePayProfile = (value) => {
    handleChange("payProfile", value);
    const find = placementId.find(
      (data) => data.uiid == formData?.Placement?.value || formData?.Placement,
    );

    const startDate = find?.jobInfo?.startDate;
    const endDate = find?.jobInfo?.endDate;
    if (!startDate) return;

    let selectedDate = dayjs(startDate);
    if (selectedDate.isAfter(dayjs())) {
      // if start date is in the future
      selectedDate = dayjs(startDate);
    } else {
      //;temporily commnet outed the correct code
      // if start date is in the past
      // selectedDate = dayjs();
      //temporay fix
      selectedDate = dayjs(startDate);
    }
    const newTableData = [];
    const newPredictData = [];

    // Helper to format date as YYYY-MM-DD

    // Helper to get last day of the month
    const getLastDayOfMonth = (date) => dayjs(date).utc().endOf("month");

    // First period: from startDate to end of that month
    let periodStart = selectedDate.utc().startOf("day");
    let periodEnd = selectedDate.utc().endOf("day");
    const isBefore15th = periodStart.date() < 15;
    const isAfter15th = periodStart.date() >= 15;
    if (isBefore15th) {
      periodStart = periodStart.subtract(1, "month").startOf("month");
      periodEnd = periodEnd.subtract(1, "month").endOf("month");
    } else if (isAfter15th) {
      periodStart = periodStart.startOf("month");
      periodEnd = periodEnd.endOf("month");
    }

    for (let i = 0; i < 5; i++) {
      const payDay = periodEnd.add(1, "month").date(15); // 15th of next month

      const label = `${exactUTCDate(periodStart)} to ${exactUTCDate(periodEnd)}`;
      const payDayFormatted = exactUTCDate(payDay);

      newPredictData.push({
        label,
        value: label,
      });

      newTableData.push({
        payPeriods: label,
        payDays: payDayFormatted,
      });

      // Next period: first and last day of the next month
      periodStart = periodEnd.add(1, "day").utc().startOf("day");
      periodEnd = getLastDayOfMonth(periodStart);
    }
    setTableData([]); // Clear current data
    setPredictData(newPredictData); // Set new data
    handleChange("payPeriod", ""); // Clear selected pay period
  };

  // creates 5 dates from placeent startdate
  // const handleChangePayPeriod = (value) => {
  //   const newTableData = [];
  //   handleChange("payPeriod", value);
  //   const formatDateLocal = (date) => date.toLocaleDateString("en-CA");
  //   // Helper: get last day of the month
  //   const getLastDayOfMonth = (date) =>
  //     new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   // Parse the exact start and end dates from the selected value (assumed format "YYYY-MM-DD to YYYY-MM-DD")
  //   const [startStr, endStr] = value.split(" to ");
  //   let periodStart = new Date(startStr);
  //   let periodEnd = new Date(endStr);
  //   // Add the exact period first
  //   const payDayForPeriod = new Date(
  //     periodEnd.getFullYear(),
  //     periodEnd.getMonth() + 1,
  //     15
  //   );
  //   newTableData.push({
  //     payPeriods: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //       periodEnd
  //     )}`,
  //     payDays: formatDateLocal(payDayForPeriod),
  //   });
  //   // Now generate next 4 full monthly periods
  //   for (let i = 0; i < 4; i++) {
  //     // Next period start: first day of the month after current periodEnd
  //     periodStart = new Date(
  //       periodEnd.getFullYear(),
  //       periodEnd.getMonth() + 1,
  //       1
  //     );
  //     // Next period end: last day of that month
  //     periodEnd = getLastDayOfMonth(periodStart);
  //     const payDay = new Date(
  //       periodEnd.getFullYear(),
  //       periodEnd.getMonth() + 1,
  //       15
  //     );
  //     newTableData.push({
  //       payPeriods: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //         periodEnd
  //       )}`,
  //       payDays: formatDateLocal(payDay),
  //     });
  //   }
  //   setTableData(newTableData);
  // };
  // const handleChangePayPeriod = (value) => {
  //   const newTableData = [];
  //   handleChange("payPeriod", value);

  //   const formatDate = (date) => dayjs(date).utc().format("MM/DD/YYYY");

  //   // Parse the selected period (assumes format: "YYYY-MM-DD to YYYY-MM-DD")
  //   const [startStr, endStr] = value.split(" to ");
  //   let periodStart = dayjs(startStr).utc().startOf("day");
  //   let periodEnd = dayjs(endStr).endOf("day");

  //   // First pay period (the selected range)
  //   const payDayForPeriod = periodEnd.add(1, "month").date(15);

  //   newTableData.push({
  //     // payPeriods: `${formatDate(periodStart)} to ${formatDate(periodEnd)}`,
  //     payPeriods: `${exactUTCDate(periodStart)} to ${exactUTCDate(periodEnd)}`,
  //     payDays: exactUTCDate(payDayForPeriod),
  //   });

  //   // Generate next 4 full calendar month periods
  //   for (let i = 0; i < 4; i++) {
  //     // Start: 1st day of next month
  //     periodStart = periodEnd.add(1, "day").utc().startOf("month");
  //     // End: last day of that month
  //     periodEnd = periodStart.utc().endOf("month");

  //     const payDay = periodEnd.add(1, "month").date(15);

  //     newTableData.push({
  //       payPeriods: `${exactUTCDate(periodStart)} to ${exactUTCDate(periodEnd)}`,
  //       payDays: exactUTCDate(payDay),
  //     });
  //   }

  //   setTableData(newTableData);
  // };
  const handleChangePayPeriod = (value) => {
    const newTableData = [];
    handleChange("payPeriod", value);

    const formatDate = (date) => dayjs(date).utc().format("MM/DD/YYYY");

    // Parse the selected period (assumes format: "YYYY-MM-DD to YYYY-MM-DD")
    const [startStr, endStr] = value.split(" to ");
    let periodStart = dayjs(startStr).utc().startOf("day");
    let periodEnd = dayjs(endStr).endOf("day");

    // First pay period (the selected range)
    const payDayForPeriod = periodEnd.add(1, "month").date(15);

    newTableData.push({
      // payPeriods: `${formatDate(periodStart)} to ${formatDate(periodEnd)}`,
      payPeriods: `${exactUTCDate(periodStart)} to ${exactUTCDate(periodEnd)}`,
      payDays: exactUTCDate(payDayForPeriod),
    });

    let numberOfMothsTillToday = dayjs().diff(selectedDate, "month") + 5 || 5;
    // Generate next 4 full calendar month periods
    for (let i = 0; i < numberOfMothsTillToday; i++) {
      // Start: 1st day of next month
      periodStart = periodEnd.add(1, "day").utc().startOf("month");
      // End: last day of that month
      periodEnd = periodStart.utc().endOf("month");

      const payDay = periodEnd.add(1, "month").date(15);

      newTableData.push({
        payPeriods: `${exactUTCDate(periodStart)} to ${exactUTCDate(periodEnd)}`,
        payDays: exactUTCDate(payDay),
      });
    }

    setTableData(newTableData);
  };

  const hasRunOnce = useRef(false);
  useEffect(() => {
    if (!hasRunOnce.current) {
      if (
        Array.isArray(filteredPlacementsActive) &&
        filteredPlacementsActive.length > 0
      ) {
        const uiid = filteredPlacementsActive[0]?.uiid;
        handleChange("Placement", uiid);
      }
      hasRunOnce.current = true;
    }
  }, [filteredPlacementsActive]);

  const handleCallApi = () => {
    const filter = { employeeId: { type: "NONE", value: employeeProfileUiid } };
    const payload = {
      coll: "EmpPayConfig",
      filters: filter,
      // ref: "Placement",
      ref: "Placement SalProfile",
      sort: {
        addedOn: -1,
      },
    };
    // showToast(`fetching payconfigurations for ${employeeProfileUiid}`);
    dispatch(
      getCurrentEmployeePayConfig({
        ...payload,
        onSuccess: (response) => {
          const findLatest = response?.data || [];
          let sortedFindLatest = findLatest.sort(
            (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
          );
          let findIndexOfpayConfig;
          if (employeeDetails?.employmentType === 4) {
            const validLevels = ["P2", "P3", "P4", "P5", "P6"];

            findIndexOfpayConfig = sortedFindLatest.findIndex((item) =>
              validLevels.includes(item.jobId?.clientPlacement?.placement),
            );
          } else {
            findIndexOfpayConfig = sortedFindLatest.findIndex(
              (item) => item.jobId?.clientPlacement?.placement === "P1",
            );
          }
          const latest = findLatest[0];
          if (!latest) return;
          // if()
          if (latest) {
            // Set form fields
            handleChange("uiid", latest?.uiid);
            handleChange("Placement", {
              label: latest.jobId?.clientPlacement?.placement,
              value: latest.jobId?.uiid,
            });
            handleChange("payProfile", {
              label: latest?.profile?.name,
              value: latest?.profile?.uiid,
            });
            handleChange("paymentType", latest?.type);
            handleChange("basePayMonth", latest.basePay);
            handleChange("wageRate", latest.lca?.wages);
            handleChange("lcatype", latest.lca?.type);
            handleChange("basePay", latest.lca?.period?.from);
            handleChange("payCycle", latest.lca?.period?.to);

            // // Table Data Setup
            // const newTableData = [];
            // const formatDateLocal = (date) =>
            //   new Date(date).toLocaleDateString("en-CA"); // Format: yyyy-mm-dd

            // const getLastDayOfMonth = (date) =>
            //   new Date(date.getFullYear(), date.getMonth() + 1, 0);

            // Setup helpers
            const formatDate = (date) => dayjs(date).format("MM/DD/YYYY");

            // Initialize period dates
            let periodStart = dayjs(latest.period.from).utc().startOf("day");
            let periodEnd = dayjs(latest.period.to).endOf("day");

            const newTableData = [];

            // First row (current period)
            const payDayForPeriod = periodEnd.add(1, "month").date(15);

            newTableData.push({
              payPeriods: `${exactUTCDate(periodStart)} to ${exactUTCDate(
                periodEnd,
              )}`,
              payDays: exactUTCDate(payDayForPeriod),
            });

            // Set the payPeriod input value
            handleChange(
              "payPeriod",
              `${exactUTCDate(periodStart)} to ${exactUTCDate(periodEnd)}`,
            );
            for (let i = 0; i < 4; i++) {
              periodStart = periodEnd.add(1, "day").utc().startOf("month");
              periodEnd = periodStart.endOf("month");
              const payDay = periodEnd.add(1, "month").date(15);
              newTableData.push({
                payPeriods: `${exactUTCDate(periodStart)} to ${exactUTCDate(
                  periodEnd,
                )}`,
                payDays: exactUTCDate(payDay),
              });
            }

            // Finalize table
            setTableData(newTableData);
          }
        },
      }),
    );
  };

  function parseDate(dateStr, separator = "/", format = "YYMMDD") {
    const dateArray = dateStr.split(separator).map(Number);
    let yyyy, mm, dd;
    switch (format) {
      case "YYMMDD":
        [yyyy, mm, dd] = dateArray;
        break;
      case "MMDDYY":
        [mm, dd, yyyy] = dateArray;
        break;
      default:
        throw new Error(`Unsupported date format: ${format}`);
    }
    // return new Date(Date.UTC(yyyy, mm - 1, dd)).toISOString();
    return new Date(Date.UTC(yyyy, mm - 1, dd));
  }

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const [startStr, endStr] = formData?.payPeriod.split(" to ");
      const fromConverted = parseDate(startStr, "/", "MMDDYY");
      const toConverted = parseDate(endStr, "/", "MMDDYY");
      console.log({ startStr, endStr });
      console.log({ fromConverted, toConverted });
      // return;
      const payload = {
        employeeId: employeeProfileUiid,
        jobId: formData?.Placement?.value,
        profile: formData?.payProfile?.value ?? formData?.payProfile,
        period: {
          from: fromConverted,
          to: toConverted,
          // from: dayjs(startStr).startOf('day').toDate(),
          // to: dayjs(endStr).endOf('day').toDate(),
        },
        type: formData?.paymentType,
        basePay: formData?.basePayMonth,
        lca: {
          wages: Number(formData?.wageRate),
          type: formData?.lcatype,
          period: {
            from: formData?.basePay,
            to: formData?.payCycle,
          },
        },
        addedBy: loginUserUiid,
      };
      const submissionData = filterEmptyValues(payload);
      const toCreatePayroll =
        employeeDetails?.employmentType !== 4 &&
        formData?.Placement?.label !== "P1"
          ? false
          : true;
      dispatch(
        addEmployeePayConfigure({
          coll: "EmpPayConfig",
          payload: submissionData,
          ...(toCreatePayroll && { createPayroll: true }),
          onSuccess: () => {
            handleCallApi();
          },
        }),
      );
    }
  };

  useEffect(() => {
    handleCallApi();
    return () => {
      dispatch(clearPlacementsData());
    };
  }, []);

  // fetching the pay configuration from parent
  // useEffect(() => {
  //   const fetchPayConfigFromParent = async () => {
  //     if (!formData?.Placement?.value) return;
  //     try {
  //       let filter = {
  //         jobId: { type: "NONE", value: formData?.Placement?.value },
  //         employeeId: { type: "NONE", value: employeeDetails?.linkedTo?.uiid },
  //       };
  //       const response = await axiosRequest({
  //         method: "GET",
  //         url: ENDPOINTS.EMPLOYEE_PAY_CONFIGURATION.GET_BY_UIID,
  //         params: {
  //           coll: "EmpPayConfig",
  //           ref: "Placement SalProfile",
  //           // ref: "Placement",
  //           // incl: ["firstName lastName employmentType uiid", "jobInfo"],
  //           fil: JSON.stringify(filter),
  //           // lim: limit,
  //           // pg: page,
  //           sort: JSON.stringify({
  //             addedOn: -1,
  //           }),
  //         },
  //       });
  //       console.log(
  //         "response for the pay config prefill from parent",
  //         response?.data?.data
  //       );
  //       const latest = response?.data?.data;
  //       if (!latest?.profile?.uiid) throw new Error("No profile found");
  //       handleChange(
  //         "payProfile",
  //         { label: latest?.profile?.name, value: latest?.profile?.uiid } || ""
  //       );
  //       handleChange("paymentType", latest?.type);
  //       handleChange("basePayMonth", latest.basePay);
  //       handleChange("wageRate", latest.lca?.wages);
  //       handleChange("lcatype", latest.lca?.type);
  //       handleChange("basePay", latest.lca?.period?.from);
  //       handleChange("payCycle", latest.lca?.period?.to);
  //       const formatDate = (date) => dayjs(date).format("MM/DD/YYYY");
  //       let periodStart = dayjs(latest.period.from).startOf("day");
  //       let periodEnd = dayjs(latest.period.to).endOf("day");
  //       // const newTableData = [];
  //       // const payDayForPeriod = periodEnd.add(1, "month").date(15);
  //       // newTableData.push({
  //       //   payPeriods: `${formatDate(periodStart)} to ${formatDate(periodEnd)}`,
  //       //   payDays: formatDate(payDayForPeriod),
  //       // });
  //       handleChange(
  //         "payPeriod",
  //         `${formatDate(periodStart)} to ${formatDate(periodEnd)}`
  //       );
  //     } catch (error) {
  //       handleChange("payProfile", "");
  //       handleChange("paymentType", "");
  //       handleChange("basePayMonth", "");
  //       handleChange("wageRate", "");
  //       handleChange("lcatype", "");
  //       handleChange("basePay", "");
  //       handleChange("payCycle", "");
  //       handleChange("payPeriod", "");
  //     }
  //   };
  //   if (employeeDetails?.employmentType == 4 && empPayConfigData.length === 0) {
  //     setTimeout(() => {
  //       fetchPayConfigFromParent();
  //     }, 100);
  //   }
  // }, [formData?.Placement?.value, empPayConfigData.length]);

  return (
    <div className="px-2 py-6">
      <div className="flex justify-end mb-4">
        <Button
        title={"Off Cycle Payment"}
        color="primary"
        variant="contained"
        onClick={() => navigate("off-cycle-payment")}
      />
      </div>
      <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-md mb-6">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-0">
        <FormFieldSet
          type="placementsForPayConfigDropDown"
          title={"Select Placement"}
          placeholder="Select Placement"
          value={formData.Placement}
          onChange={(value) => {
            handleChange("Placement", value);
            setTableData([]);
            setPredictData([]);
            handleChange("payPeriod", "");
            handleChange("lcatype", "");
          }}
          parentValue={{
            entityId:
              employeeDetails?.employmentType === 4
                ? employeeDetails?.linkedTo?.uiid
                : employeeProfileUiid,
            entityType: employeeDetails?.employmentType === 4 ? true : false,
          }}
          error={errors.Placement}
          // options={formattedPlacements}
          disabled={empPayConfigData.length > 0}
        />
        <FormFieldSet
          type="allPayProfiles"
          title={"Pay Profile"}
          placeholder="Select Pay Profile"
          value={formData.payProfile}
          onChange={(value) => handleChangePayProfile(value)}
          error={errors.payProfile}
          showButton
          showSearch
          options={PayProfileoptions}
          disabled={empPayConfigData.length > 0}
        />
        <FormFieldSet
          type="select"
          title={"Pay Period"}
          placeholder="Select Pay Period"
          value={formData.payPeriod}
          onChange={(value) => handleChangePayPeriod(value)}
          error={errors.payPeriod}
          // showButton
          // showSearch
          options={predictData}
          disabled={empPayConfigData.length > 0}
        />
        <FormFieldSet
          type="select"
          title={"Payment Type"}
          placeholder="Select Payment Type"
          value={formData.paymentType}
          onChange={(value) => handleChange("paymentType", value)}
          error={errors.paymentType}
          options={Paymenttypeopetions}
          disabled={empPayConfigData.length > 0}
        />
        <div>
          <FormFieldSet
            type="text"
            title={"Base pay"}
            placeholder="Enter Base pay"
            value={formData.basePayMonth}
            onChange={(value) => handleChange("basePayMonth", value)}
            error={errors.basePayMonth}
            options={BasepayOpetions}
            disabled={employeeDetails?.employmentType === 4 ? false : true}
          />
        </div>
        <FormFieldSet
          type="text"
          title={"LCA Wages"}
          placeholder="Enter LCA Wages"
          value={formData.wageRate}
          onChange={(value) => handleChange("wageRate", value)}
          error={errors.wageRate}
          options={BasepayOpetions}
          // disabled={empPayConfigData.length>0}
          disabled={employeeDetails?.employmentType === 4 ? false : true}
        />
        <FormFieldSet
          type="select"
          title={"LCA Type "}
          placeholder="LCA Type"
          value={formData.lcatype}
          onChange={(value) => handleLcaType(value)}
          error={errors.lcatype}
          options={LCStypes}
          disabled={empPayConfigData.length > 0}
        />

        <div className="col-span-1 flex gap-1 ">
          <FormFieldSet
            type="datepicker"
            title={"LCA Time Period"}
            placeholder="Pick Date"
            value={formData.basePay}
            onChange={(value) => handleChange("basePay", value)}
            error={errors.basePay}
            disabled={employeeDetails?.employmentType === 4 ? false : true}
            showDropdown={false}
          />
          <div>
            <FormFieldSet
              type="datepicker"
              title={" "}
              placeholder="Pick Date"
              value={formData.payCycle}
              onChange={(value) => handleChange("payCycle", value)}
              error={errors.payCycle}
              options={BasepayOpetions}
              disabled={employeeDetails?.employmentType === 4 ? false : true}
              showDropdown={false}
            />
          </div>
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-6">
        <Button
          title={"Cancel"}
          variant="outlined"
          // onClick={() => handleCancel()}
        />
        <Button
          title={"Save"}
          onClick={() => handleSave()}
          disabled={empPayConfigData.length > 0}
        />
      </div>
      <div className="my-6">
        <PageHeader
          Section={
            <div>
              Next 5 Pay Days and Pay Periods for the selected Pay Profile:
              <span className="font-medium"> W2 Payroll (Monthly)</span>
            </div>
          }
          RightSection={
            <div className="flex">
              <Button
                variant="text"
                title={"Revise"}
                icon={"change_circle"}
                // disabled={employeeDetails?.employmentType === 4 ? true : false}
                onClick={() =>
                  setISReviseTimesheetsModal(!isReviseTimesheetsModal)
                }
              />
              <Button
                variant="text"
                title={"Change Pay Profile"}
                icon={"swap_horizontal_circle"}
                disabled={employeeDetails?.employmentType === 4 ? true : false}
                onClick={() => setISAdjustPayCycleModal(!isAdjustPayCycleModal)}
              />
              <Button
                variant="text"
                title={"Revisions History"}
                icon={"data_table"}
                disabled={employeeDetails?.employmentType === 4 ? true : false}
                onClick={() =>
                  setShowRevisionHistoryModal(!showRevisionHistoryModal)
                }
              />
            </div>
          }
          className="flex-col! lg:flex-row!"
        />
        <TableAdv tableId={`employee_payments_payconfiguration`} columns={PayPeriodColumns} rows={mappedRows} hideToolBar />
        <span className="text-xs">
          * Based on Weekends and Holidays Configurations
        </span>

        <div className="mt-6">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"Employee Placement"} tag="h6" />
              </div>
            }
          />
          <div className="tabs mt-3">
            <div className="flex gap-2">
              {[1, 2].map((tabIndex) => (
                <Button
                  key={tabIndex}
                  title={tabIndex === 1 ? "Active" : "Inactive"}
                  variant="text"
                  onClick={() => setActiveTab(tabIndex)}
                  color={activeTab === tabIndex ? "primary" : "black"}
                  className={
                    activeTab === tabIndex
                      ? "border-b-2 border-primary text-primary rounded-none"
                      : "border-b-2 border-white text-black rounded-none"
                  }
                />
              ))}
            </div>
            <Divider />
            <div className="flex">
              <div className="mt-2 w-full flex-1">
                {activeTab === 1 && (
                  <div>
                    {filteredPlacementsActive
                      .filter((data) => data._id !== formData?.Placement)
                      .map((data, index) => (
                        <div
                          key={data._id || index}
                          className="rounded-xl border border-gray-200 shadow-md p-6 bg-white w-full mt-8"
                        >
                          <div className="flex justify-between items-start">
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <h6 className="font-semibold text-gray-800">
                                  {data?.jobInfo?.billClient?.businessName ||
                                    "No Business Name"}
                                </h6>
                                <StatusTags
                                  tag={data?.clientPlacement?.placement}
                                  icon={true}
                                  variant="outlined"
                                />
                              </div>
                              {/* {console.log("data for showing placement", data)} */}
                              <p className="text-sm text-gray-500">
                                {formatWords2(data?.jobInfo?.jobTitle) ||
                                  "No Job Title"}{" "}
                                -{" "}
                                {/* {data?.clientPlacement?.placement || "-"} */}
                              </p>
                              <p className="text-sm text-gray-400">
                                {data?.jobInfo?.startDate
                                  ? new Date(
                                      data.jobInfo.startDate,
                                    ).toLocaleDateString()
                                  : "No Start Date"}{" "}
                                -{" "}
                                {data?.jobInfo?.endDate
                                  ? new Date(
                                      data.jobInfo.endDate,
                                    ).toLocaleDateString()
                                  : "No End Date"}
                              </p>
                            </div>
                            <div className="flex gap-4 items-start">
                              {/* <InfoTimeCardAdv
                                title="Bill Rate"
                                // value="$57.80"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.billRate?.rate != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .billRate.rate,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                size="md"
                                color="primary"
                              /> */}
                              <InfoCardNewAdv
                                title="Bill Rate"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.billRate?.rate != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .billRate.rate,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                layout="option12"
                                valueConfig={{
                                  className: "text-[28px] text-primary!",
                                }}
                              />
                              <Divider orientation="vertical" />
                              {/* <InfoTimeCardAdv
                                title="Pay Rate"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.payRate?.payRatePerHour != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .payRate?.payRatePerHour,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                size="md"
                                color="primary"
                              /> */}
                              <InfoCardNewAdv
                                title="Pay Rate"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.payRate?.payRatePerHour != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .payRate?.payRatePerHour,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                layout="option12"
                                valueConfig={{
                                  className: "text-[28px] text-primary!",
                                }}
                              />
                              <Divider orientation="vertical" />
                            </div>
                          </div>
                          <div className=" grid grid-cols-4 gap-x-8 gap-y-6 w-full mt-4">
                            {/* <div className="flex items-end gap-2">
                              <div className="flex-1">
                                <FormFieldSet
                                  type="select"
                                  title={"Link With Pay Data"}
                                  placeholder="Select "
                                  value={formData.payType}
                                  onChange={(value) =>
                                    handleChange("payType", value)
                                  }
                                  error={errors.payType}
                                  options={PayType}
                                />
                              </div>
                              <Button
                                type="icon"
                                size="sm"
                                color="dark"
                                variant="text"
                                icon="edit_square"
                                onClick={() => setIsPayTypeModalOpen(true)}
                              />
                            </div>
                            <div className="flex items-end gap-2">
                              <div className="flex-1">
                                <FormFieldSet
                                  type="select"
                                  title={"TimeSheet to Consideer"}
                                  placeholder="Select "
                                  value={formData.payType}
                                  onChange={(value) =>
                                    handleChange("payType", value)
                                  }
                                  error={errors.payType}
                                  options={PayType}
                                />
                              </div>
                              <Button
                                type="icon"
                                size="sm"
                                color="dark"
                                variant="text"
                                icon="edit_square"
                                onClick={() => setIsPayTypeModalOpen(true)}
                              />
                            </div>
                            <div className="flex justify-end mt-4 text-xs text-gray-400">
                              <div className="mr-6">Last Modified By: --</div>
                              <div>Modified On: --</div>
                            </div>*/}
                          </div>
                        </div>
                      ))}
                    {/* 
                    <div className="rounded-xl border border-gray-200 shadow-md p-6 bg-white w-full mt-8">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h6 className="font-semibold text-gray-800">
                            Seaglass Technology Partners
                          </h6>
                          <p className="text-sm text-gray-500">
                            Software Engineer III_Seaglass (SeaglassTech_001)
                          </p>
                          <p className="text-sm text-gray-400">
                            11/21/2022 - 12/31/2025
                          </p>
                        </div>
                        <div className="flex gap-4 items-start">
                          <InfoTimeCardAdv
                            title="Bill Rate"
                            value="$57.80"
                            size="md"
                            color="primary"
                          />
                          <Divider orientation="vertical" />
                          <InfoTimeCardAdv
                            title="Pay Rate"
                            value="$57.80"
                            size="md"
                            color="primary"
                          />
                          <Divider orientation="vertical" />
                        </div>
                      </div>
                      <div className=" grid grid-cols-4 gap-x-8 gap-y-6 w-full mt-4">
                        <div className="flex items-end gap-2">
                          <div className="flex-1">
                            <FormFieldSet
                              type="select"
                              title={"Link With Pay Data"}
                              placeholder="Select "
                              value={formData.payType}
                              onChange={(value) =>
                                handleChange("payType", value)
                              }
                              error={errors.payType}
                              options={PayType}
                            />
                          </div>
                          <Button
                            type="icon"
                            size="sm"
                            color="dark"
                            variant="text"
                            icon="edit_square"
                            onClick={() => setIsPayTypeModalOpen(true)}
                          />
                        </div>
                        <div className="flex items-end gap-2">
                          <div className="flex-1">
                            <FormFieldSet
                              type="select"
                              title={"TimeSheet to Consideer"}
                              placeholder="Select "
                              value={formData.payType}
                              onChange={(value) =>
                                handleChange("payType", value)
                              }
                              error={errors.payType}
                              options={PayType}
                            />
                          </div>
                          <Button
                            type="icon"
                            size="sm"
                            color="dark"
                            variant="text"
                            icon="edit_square"
                            onClick={() => setIsPayTypeModalOpen(true)}
                          />
                        </div>
                        <div className="flex justify-end mt-4 text-xs text-gray-400">
                          <div className="mr-6">Last Modified By: --</div>
                          <div>Modified On: --</div>
                        </div>
                      </div>
                    </div>

                    <div className="rounded-xl border border-gray-200 shadow-md p-6 bg-white w-full mt-8">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h6 className="font-semibold text-gray-800">
                            Seaglass Technology Partners
                          </h6>
                          <p className="text-sm text-gray-500">
                            Software Engineer III_Seaglass (SeaglassTech_001)
                          </p>
                          <p className="text-sm text-gray-400">
                            11/21/2022 - 12/31/2025
                          </p>
                        </div>
                        <div className="flex gap-4 items-start">
                          <InfoTimeCardAdv
                            title="Bill Rate"
                            value="$57.80"
                            size="md"
                            color="primary"
                          />
                          <Divider orientation="vertical" />
                          <InfoTimeCardAdv
                            title="Pay Rate"
                            value="$57.80"
                            size="md"
                            color="primary"
                          />
                          <Divider orientation="vertical" />
                        </div>
                      </div>
                      <div className=" grid grid-cols-4 gap-x-8 gap-y-6 w-full mt-4">
                        <div className="flex items-end gap-2">
                          <div className="flex-1">
                            <FormFieldSet
                              type="select"
                              title={"Link With Pay Data"}
                              placeholder="Select"
                              value={formData.payType}
                              onChange={(value) =>
                                handleChange("payType", value)
                              }
                              error={errors.payType}
                              options={PayType}
                            />
                          </div>
                          <Button
                            type="icon"
                            size="sm"
                            color="dark"
                            variant="text"
                            icon="edit_square"
                            onClick={() => setIsPayTypeModalOpen(true)}
                          />
                        </div>
                        <div className="flex items-end gap-2">
                          <div className="flex-1">
                            <FormFieldSet
                              type="select"
                              title={"TimeSheet to Consideer"}
                              placeholder="Select"
                              value={formData.payType}
                              onChange={(value) =>
                                handleChange("payType", value)
                              }
                              error={errors.payType}
                              options={PayType}
                            />
                          </div>
                          <Button
                            type="icon"
                            size="sm"
                            color="dark"
                            variant="text"
                            icon="edit_square"
                            onClick={() => setIsPayTypeModalOpen(true)}
                          />
                        </div>
                        <div className="flex justify-end mt-4 text-xs text-gray-400">
                          <div className="mr-6">Last Modified By: --</div>
                          <div>Modified On: --</div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                )}
                {activeTab === 2 && (
                  // <div className="rounded-xl border border-gray-200 shadow-md p-6 bg-white w-full mt-8">
                  //   <div className="flex justify-between items-start">
                  //     <div className="flex-1">
                  //       <h6 className="font-semibold text-gray-800">
                  //         Seaglass Technology Partners
                  //       </h6>
                  //       <p className="text-sm text-gray-500">
                  //         Software Engineer III_Seaglass (SeaglassTech_001)
                  //       </p>
                  //       <p className="text-sm text-gray-400">
                  //         11/21/2022 - 12/31/2025
                  //       </p>
                  //     </div>
                  //     <div className="flex gap-4 items-start">
                  //       <InfoTimeCardAdv
                  //         title="Bill Rate"
                  //         value="$57.80"
                  //         size="md"
                  //         color="primary"
                  //         suffix=""
                  //       />
                  //       <Divider orientation="vertical" />
                  //       <InfoTimeCardAdv
                  //         title="Pay Rate"
                  //         value="$57.80"
                  //         size="md"
                  //         color="primary"
                  //       />
                  //     </div>
                  //   </div>
                  //   <div className=" grid grid-cols-4 gap-x-8 gap-y-6 w-full mt-4">
                  //     <div className="flex items-end gap-2">
                  //       <div className="flex-1">
                  //         <FormFieldSet
                  //           type="select"
                  //           title={"Link With Pay Data"}
                  //           placeholder="Select"
                  //           value={formData.payType}
                  //           onChange={(value) => handleChange("payType", value)}
                  //           error={errors.payType}
                  //           options={PayType}
                  //         />
                  //       </div>
                  //       <Button
                  //         type="icon"
                  //         size="sm"
                  //         color="dark"
                  //         variant="text"
                  //         icon="edit_square"
                  //         onClick={() => setIsPayTypeModalOpen(true)}
                  //       />
                  //     </div>
                  //     <div className="flex items-end gap-2">
                  //       <div className="flex-1">
                  //         <FormFieldSet
                  //           type="select"
                  //           title={"TimeSheet to Consideer"}
                  //           placeholder="Select"
                  //           value={formData.payType}
                  //           onChange={(value) => handleChange("payType", value)}
                  //           error={errors.payType}
                  //           options={PayType}
                  //         />
                  //       </div>
                  //       <Button
                  //         type="icon"
                  //         size="sm"
                  //         color="dark"
                  //         variant="text"
                  //         icon="edit_square"
                  //         onClick={() => setIsPayTypeModalOpen(true)}
                  //       />
                  //     </div>
                  //     <div className="flex justify-end mt-4 text-xs text-gray-400">
                  //       <div className="mr-6">Last Modified By: --</div>
                  //       <div>Modified On: --</div>
                  //     </div>
                  //   </div>
                  // </div>
                  <div>
                    {filteredPlacementsInactive
                      .filter((data) => data._id !== formData?.Placement)
                      .map((data, index) => (
                        <div
                          key={data._id || index}
                          className="rounded-xl border border-gray-200 shadow-md p-6 bg-white w-full mt-8"
                        >
                          <div className="flex justify-between items-start">
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <h6 className="font-semibold text-gray-800">
                                  {data?.jobInfo?.billClient?.businessName ||
                                    "No Business Name"}
                                </h6>
                                <StatusTags
                                  tag={data?.clientPlacement?.placement}
                                  icon={true}
                                  variant="outlined"
                                />
                              </div>
                              <p className="text-sm text-gray-500">
                                {formatWords2(data?.jobInfo?.jobTitle) ||
                                  "No Job Title"}{" "}
                                -{" "}
                                {/* {data?.clientPlacement?.placement || "-"} */}
                              </p>
                              <p className="text-sm text-gray-400">
                                {data?.jobInfo?.startDate
                                  ? new Date(
                                      data.jobInfo.startDate,
                                    ).toLocaleDateString()
                                  : "No Start Date"}{" "}
                                -{" "}
                                {data?.jobInfo?.endDate // <--- Fix applied here
                                  ? new Date(
                                      data.jobInfo.endDate,
                                    ).toLocaleDateString()
                                  : "No End Date"}
                              </p>
                            </div>
                            <div className="flex gap-4 items-start">
                              {/* <InfoTimeCardAdv
                                title="Bill Rate"
                                // value="$57.80"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.billRate?.rate != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .billRate.rate,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                size="md"
                                color="primary"
                              /> */}
                              <InfoCardNewAdv
                                title="Bill Rate"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.billRate?.rate != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .billRate.rate,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                layout="option12"
                                valueConfig={{
                                  className: "text-[28px] text-primary!",
                                }}
                              />
                              <Divider orientation="vertical" />
                              {/* <InfoTimeCardAdv
                                title="Pay Rate"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.payRate?.payRatePerHour != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .payRate?.payRatePerHour,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                size="md"
                                color="primary"
                              /> */}
                              <InfoCardNewAdv
                                title="Pay Rate"
                                value={
                                  data?.payments?.[data.payments.length - 1]
                                    ?.payRate?.payRatePerHour != null
                                    ? `$${Number(
                                        data.payments[data.payments.length - 1]
                                          .payRate?.payRatePerHour,
                                      ).toFixed(2)}`
                                    : ""
                                }
                                layout="option12"
                                valueConfig={{
                                  className: "text-[28px] text-primary!",
                                }}
                              />
                              <Divider orientation="vertical" />
                            </div>
                          </div>
                          <div className=" grid grid-cols-4 gap-x-8 gap-y-6 w-full mt-4">
                            {/* <div className="flex items-end gap-2">
                              <div className="flex-1">
                                <FormFieldSet
                                  type="select"
                                  title={"Link With Pay Data"}
                                  placeholder="Select "
                                  value={formData.payType}
                                  onChange={(value) =>
                                    handleChange("payType", value)
                                  }
                                  error={errors.payType}
                                  options={PayType}
                                />
                              </div>
                              <Button
                                type="icon"
                                size="sm"
                                color="dark"
                                variant="text"
                                icon="edit_square"
                                onClick={() => setIsPayTypeModalOpen(true)}
                              />
                            </div>
                            <div className="flex items-end gap-2">
                              <div className="flex-1">
                                <FormFieldSet
                                  type="select"
                                  title={"TimeSheet to Consideer"}
                                  placeholder="Select "
                                  value={formData.payType}
                                  onChange={(value) =>
                                    handleChange("payType", value)
                                  }
                                  error={errors.payType}
                                  options={PayType}
                                />
                              </div>
                              <Button
                                type="icon"
                                size="sm"
                                color="dark"
                                variant="text"
                                icon="edit_square"
                                onClick={() => setIsPayTypeModalOpen(true)}
                              />
                            </div>
                            <div className="flex justify-end mt-4 text-xs text-gray-400">
                              <div className="mr-6">Last Modified By: --</div>
                              <div>
                                Modified On:{" "}
                                {data?.updatedAt
                                  ? new Date(data.updatedAt).toLocaleDateString(
                                      "en-US",
                                      {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                      }
                                    )
                                  : "No Date"}
                              </div>
                            </div>*/}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div>
        <ReviseTimesheetsModal
          open={isReviseTimesheetsModal}
          onClose={() => setISReviseTimesheetsModal(!isReviseTimesheetsModal)}
          setTableData={setTableData}
          tableData={tableData}
          predictData={predictData}
          setPredictData={setPredictData}
          filteredPlacementsActive={filteredPlacementsActive}
          formattedPlacements={formattedPlacements}
          empPayConfigData={empPayConfigData}
          LCStypes={LCStypes}
          lcaList={lcaList}
          handleCallApi={handleCallApi}
          employeeProfileUiid={employeeProfileUiid}
          loginUserUiid={loginUserUiid}
          dispatch={dispatch}
          formDataFromParent={formData}
          placementId={placementId}
        />
      </div>
      <div>
        <AdjustPayCycleModal
          open={isAdjustPayCycleModal}
          onClose={() => setISAdjustPayCycleModal(!isAdjustPayCycleModal)}
        />
      </div>
      <div>
        <ShowRevisionHistoryModal
          open={showRevisionHistoryModal}
          onClose={() => setShowRevisionHistoryModal(!showRevisionHistoryModal)}
        />
      </div>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};
export default Payconfigurations;
